import { Input } from '../ui/components/formik'
import Button from '../ui/components/formik/button'
import Textarea from '../ui/components/formik/textarea'
import InputPassword from '../ui/components/formik/input-password'

const ComponentsList = {
  Input: Input,
  Textarea: Textarea,
  Button: Button,
  InputPassword
}

export default ComponentsList
